import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import {
  generateCodeChallenge,
  generateCodeVerifier,
  generateRandomState,
} from "../lib/helper";
// const generateCodeVerifier = () => {
//   return window.crypto.getRandomValues(new Uint8Array(32)).toString();
// };

// function generateRandomState() {
//   const array = new Uint8Array(16);
//   window.crypto.getRandomValues(array);
//   return Array.from(array, (byte) => byte.toString(16).padStart(2, "0")).join(
//     ""
//   );
// }

// const generateCodeChallenge = async (verifier) => {
//   const encoder = new TextEncoder();
//   const data = encoder.encode(verifier);
//   const digest = await window.crypto.subtle.digest("SHA-256", data);
//   return btoa(String.fromCharCode(...new Uint8Array(digest)))
//     .replace(/=/g, "")
//     .replace(/\+/g, "-")
//     .replace(/\//g, "_");
// };

const Login = () => {
  const [authUrl, setAuthUrl] = useState("");
  const [state, setState] = useState("");

  const [searchParams, setSearchParams] = useSearchParams();
  // const params1=useSearchParams();
  //  const state = crypto.lib.WordArray.random(16).toString();

  // Store the code verifier in sessionStorage for later use
  // sessionStorage.setItem(`code_verifier_${state}`, codeVerifier);

  // const scopes = process.env.REACT_APP_SPECIFIC_SCOPES.split(" ");
  // const scopeParam = scopes.map(encodeURIComponent).join("%20");
  const scopes = process.env.REACT_APP_SPECIFIC_SCOPES;
  const scopeParam = scopes;
  useEffect(() => {
    localStorage.setItem("ref", "login");
    const initAuthProcess = async () => {
      const verifier = generateCodeVerifier();
      const newState = generateRandomState();
      localStorage.setItem("verifier", verifier);
      localStorage.setItem("state", state);

      const launch = searchParams.get("launch");
      const challenge = await generateCodeChallenge(verifier);
      const params = new URLSearchParams({
        client_id: process.env.REACT_APP_CLIENT_ID,
        aud: process.env.REACT_APP_EPIC_FHIR_BASE_URL,
        redirect_uri: process.env.REACT_APP_REDIRECT_URI,
        scope: scopeParam,
        response_type: "code",
        code_challenge: challenge,
        state: newState,
        code_challenge_method: "S256",
      });

      if (launch) {
        params.append("launch", launch);
      }

      // const authLink = `${process.env.REACT_APP_MELDRX_BASE_URL}/connect/authorize?${params.toString()}`;
      const authLink = `${
        process.env.REACT_APP_EPIC_AUTH_URL
      }?${params.toString()}`;

      setAuthUrl(authLink);
      window.location.href = authLink; // Redirect after setting state
    };

    initAuthProcess();
  }, []);

  return null; // No UI required since redirecting
};

export default Login;
